var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaderOverlay"},[_c('div',[(_vm.errorText)?[_c('h5',[_vm._v(_vm._s(_vm.errorText))]),_vm._v(" "),_c('router-link',{staticClass:"loader__link",attrs:{"to":{name: 'Locations'}}},[_vm._v("Choose different restaurant")])]:_c('img',{staticClass:"spinner",attrs:{"src":_vm.staticDir('/images/icons/icon-loader.svg'),"alt":"Loading..."}})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e91ff7f4","hasScoped":false,"optionsId":"4","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/loader.vue
// module id = null
// module chunks = 